var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex flex_center"},[_c('div',{staticClass:"legend_color_box confirmations_required_row"}),_c('span',[_vm._v(_vm._s(_vm.$t("investor.allInvestments.revolvingPutOptions.confirmationsRequired")))])])}
var staticRenderFns = []

export { render, staticRenderFns }